/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Dispatched_PendingInputs */

const en_chat_dispatched_pending = /** @type {(inputs: Chat_Dispatched_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for RMF assignment…`)
};

const fr_chat_dispatched_pending = /** @type {(inputs: Chat_Dispatched_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente d'assignation par RMF…`)
};

const ms_sg2_chat_dispatched_pending = /** @type {(inputs: Chat_Dispatched_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunggu RMF tugaskan…`)
};

/**
* | output |
* | --- |
* | "Waiting for RMF assignment…" |
*
* @param {Chat_Dispatched_PendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_dispatched_pending = /** @type {((inputs?: Chat_Dispatched_PendingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dispatched_PendingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_dispatched_pending(inputs)
	if (locale === "fr") return fr_chat_dispatched_pending(inputs)
	return ms_sg2_chat_dispatched_pending(inputs)
});